import Hero from './components/Hero';
import WhyChooseUs from './components/WhyChooseUs';
import Services from './components/Services';
// import BeforeAfter from './components/BeforeAfter';
// Testimonials are hidden until real customer reviews exist (the current ones are AI-generated placeholders).
// import SocialProof from './components/SocialProof';
import HowItWorks from './components/HowItWorks';
import ServiceAreas from './components/ServiceAreas';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <main>
        <WhyChooseUs />
        <Services />
        {/* <BeforeAfter /> */}
        {/* <SocialProof /> */}
        <HowItWorks />
        <ServiceAreas />
        <FAQ />
        <CTASection />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
